import {JobInterface} from '../../../../core/job-runner/job/job.interface';
import {JobContext} from '../../../../core/job-runner/context/job.context';
import {Observable} from 'rxjs';
import {JobExecutionStatus} from '../../../../core/job-runner/job/job-execution-status';
import {ConditionInterface} from '../../../../core/job-runner/condition/condition.interface';
import {AbstractJob} from '../../../../core/job-runner/job/abstract.job';
import {AbstractGenericGridComponent} from '../../../content-renderer/elements/abstract-generic-grid.component';

export class SetupWorkHourMonthlyEntryGridComponentJob extends AbstractJob implements JobInterface {

  run(context: JobContext, condition: ConditionInterface): Observable<JobExecutionStatus> {
    return Observable.create((observer) => {
      const component = context.component,
        workHour: any = condition.getPayload().workHour;

      if (component instanceof AbstractGenericGridComponent && workHour.id) {
        component.staticFilters.push({
          field: 'workHour',
          value: workHour.id
        });

        observer.next({
          status: true,
          content: null,
          jobId: this.jobId
        });

        observer.complete();
      } else {
        observer.next({
          status: false,
          content: 'Wrong component set',
          jobId: this.jobId
        });

        observer.complete();
      }
    });
  }
}
